// src/utils/ScannerErrorBoundary.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

class ScannerErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('Scanner error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ 
          p: 3, 
          textAlign: 'center', 
          minHeight: '300px', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center' 
        }}>
          <Typography color="text.secondary" gutterBottom>
            Camera access interrupted
          </Typography>
          <Button 
            variant="outlined" 
            onClick={() => this.setState({ hasError: false })}
            sx={{ mt: 2, alignSelf: 'center' }}
          >
            Try Again
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ScannerErrorBoundary;